"use strict";
module.exports = require("./lib/client/number");
